/* unplugin-vue-components disabled */import { render } from "./PriceCalculateQuestionView.vue?vue&type=template&id=2e2eb880&scoped=true"
import script from "./PriceCalculateQuestionView.vue?vue&type=script&lang=js"
export * from "./PriceCalculateQuestionView.vue?vue&type=script&lang=js"

import "./PriceCalculateQuestionView.vue?vue&type=style&index=0&id=2e2eb880&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e2eb880"]])

export default __exports__